import { render } from "./UserCart.vue?vue&type=template&id=52442cf6&scoped=true"
import script from "./UserCart.vue?vue&type=script&lang=js"
export * from "./UserCart.vue?vue&type=script&lang=js"

import "./UserCart.vue?vue&type=style&index=0&id=52442cf6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52442cf6"]])

export default __exports__